// extracted by mini-css-extract-plugin
module.exports = {"control":"AddMovie_control__1Tdsv"};